@if (!!key) {
  <div class="relative">
    <button class="btn btn-outline-primary"
      tooltip="{{ 'tooltip.help' | translate }}"
      type="button"
      (click)="onClick()">
      <span class="fa fa-fw fa-info-circle"></span>
    </button>
  </div>
}
